// done: change itemsperpage automate page number
// done: truncate if origin path has infinite slashes
import { Fragment, useEffect, useState } from "react";
import { saveAs } from "file-saver";
import { useHistory } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import magnifierImg from "src/img/magnifier.png";
import Resize from "src/components/common/resize";
import TransitionWidthHeight from "src/components/common/TransitionWidthHeight";
import UserInfo from "src/components/common/userInfo";
import AddForm from "src/components/forms/addForm";
import FilterForm from "src/components/forms/filterForm";
import Detail from "src/components/forms/detail";
import Export from "src/components/forms/export";
import { opts } from "src/components/forms/addForm";
import Footer from "src/components/common/frame/footer";
import { useMyStore } from "src/components/main/mainStore";
import { 
    onlyUnique,
    boolAndReducer, 
    weeknum, 
    myAxios, 
    MyFormData, 
    mimeTypeMap, 
    scroll,
    isMobilePhone,
    objDescSort,
    MyDate,
    getTimeStamp,
    isDevMode,
    getDatefromWeekNum0,
    appTitle
} from "src/components/common/functions";
import { StatusForm } from "./statusForm";
import WeekSelect from "../common/frame/weekSelect";
//--------------------------------------------------------------------------------------------
export default function Forms({ tabTitle }){
    
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);

    const history = useHistory();
    const path = history.location.pathname;
    const path1 = decodeURIComponent(path.split("/")[1] ?? "");
    const path2 = decodeURIComponent(path.split("/")[2] ?? "");
    const path3 = decodeURIComponent(path.split("/")[3] ?? "");
 
    const [updateDateTime, setUpdateDateTime] = useState(getTimeStamp());
    const [isHistory, setHistory] = useState(false);
    const [formPicData, formSetPicData] = useState([]);
    const [formSketches, formSetSketches] = useState([]);
    const statusColorCode = status => {
        switch(status){
            case "Submitted":
                return "black";
            case "Re-Submitted":
                return "purple";
            case "Approved":
                return "green";
            case "Rejected":
                return "gray";
            default:
        }
    }
    //--------------------------------------------------------------------------------------------
    const defaultFilter = {
        void: "0", 
        submitter: "",
        requestDate: "",
        totalMin: "",
        totalMax: "",
        approver: "",
        status: "",
        department: ""
    };
    const [curTruck, setTruck] = useState("");
    const [curDate, setDate] = useState("");
    const [curFilter, setFilter] = useState(defaultFilter);
    const [showFilter, setShowFilterForm] = useState(false);
    const [showStatusForm, setShowStatusForm] = useState(false);
    const [curWeekStart, setWeekStart] = useState(weeknum(new MyDate()));
    const [curWeekEnd, setWeekEnd] = useState(weeknum(new MyDate()));
    const [userList, setUserList] = useState([]);
    const [showLoading, setShowLoading] = useState(false);
    const [usersList, setUsersList] = useState([]);
    const [usersListMap, setUsersListMap] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [filterWords, setFilterWords] = useState("");
    const [curType, setType] = useState("");
    //--------------------------------------------------------------------------------------------

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filterUserList = userList?.map(u => ({...u, 
        status: u.void === "1"?"Void":((!u.dateSaved && !u.dateSubmitted)?"Created":u.dateCompleted?"Handled":(u.dateSubmitted?"Submitted":"Saved"))
    })).filter(u => 
        (isHistory?u.status === "Handled":u.status !== "Handled")
        && (user.projects === "no"?user.email === u.submitterEmail || (user.email === JSON.parse(u.formContent || "{}")["Tech"]):true)
        && (curWeekStart?(weeknum(u.dateCreated.substring(0, 10)) >= curWeekStart):true)
        && (curWeekEnd?(weeknum(u.dateCreated.substring(0, 10)) <= curWeekEnd):true)
        && (curFilter.void === "All" ? true : (String(u.void) === curFilter.void))
        && (curFilter.submitterEmail?u.submitterEmail === curFilter.submitterEmail:true)
        && (curFilter.department?u.department === curFilter.department:true)
        && (curFilter.requestDate?JSON.parse(u.data).map(u => u.date).includes(curFilter.requestDate):true)
        && (curFilter.totalMin?window.Number.parseFloat(u.totalHours) >= window.Number.parseFloat(curFilter.totalMin):true)
        && (curFilter.totalMax?window.Number.parseFloat(u.totalHours) <= window.Number.parseFloat(curFilter.totalMax):true)
        && (curType?u.formType === curType:true)
        && (curTruck?JSON.parse(u.formContent || "{}")["Truck Number"] === curTruck:true)
        && (curDate?JSON.parse(u.formContent || "{}")["Date"] === curDate:true)
        && (curFilter.approver?u.approverEmail === curFilter.approver:true)
        && (curFilter.status?u.status === curFilter.status:true)
        && (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(u)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    );
    const currentUserList = filterUserList.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filterUserList.length / itemsPerPage)}, (_, i) => (i + 1));
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const getData = async() => {
            //---------------------------------------------------------------
            setShowLoading(true);
            const resUser = await myAxios("forms/readUserNames.php");
            if(!isMounted) return;
            setShowLoading(false);
            if(!resUser) return;
            //---------------------------------------------------------------
            const users = resUser.data.map(user => ({...user, value: user.email, label: user.userName}));
            setUsersList(users);
            setUsersListMap(Object.fromEntries(users.map(user => 
                [user.value, user.label]
            )));
        }
        getData();
        return () => {isMounted = false}
    },[updateDateTime])
    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();
        const getData = async() => {
            if(isDevMode) console.log("useEffect main");
            let realWeekStart = curWeekStart;
            let realWeekEnd = curWeekEnd;
            if(path2 !== "Add" && path2 !== ""){
                const formData = new MyFormData();
                formData.append("formHashKey", path2);
                setShowLoading(true);
                const formRes = await myAxios("forms/readForm.php", formData);
                if(!isMounted) return;
                setShowLoading(false);
                if(!formRes) return;
                const potentialForm = formRes.data;
                if(potentialForm === ""){
                    history.replace(`/${path1}`);
                }else{
                    if(potentialForm.void === "1") setFilter(f => ({...f, void: "1"}));
                    if(potentialForm.dateCompleted) setHistory(true);
                    realWeekStart = weeknum(potentialForm.dateCreated.substring(0, 10));
                    realWeekEnd = weeknum(potentialForm.dateCreated.substring(0, 10));
                    setWeekStart(realWeekStart);
                    setWeekEnd(realWeekEnd);
                }
            }else{
                realWeekStart = curWeekStart;
                realWeekEnd = curWeekEnd;
            }
            const formData = new MyFormData();
            // formData.append("start", getDatefromWeekNum0(realWeekStart, 0).s());
            // formData.append("end", getDatefromWeekNum0(realWeekEnd, 7).s());
            setShowLoading(true);
            const res = await myAxios("forms/readForms.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            setUserList(res.data);
        }
        getData();
        return () => {
            isMounted = false;
            controller.abort();
        }
    },[updateDateTime])
    useEffect(() => {
        if(path2 && path2 !== "Add" && filterUserList.length){
            const thisForm = filterUserList.find(renderedForm => renderedForm.formHashKey === path2);
            const hashkeys = filterUserList
            .filter(u => u.void === thisForm.void)
            .filter(u => weeknum(u.dateCreated.substring(0, 10)) === weeknum(thisForm.dateCreated.substring(0, 10)))
            .map(v => v.formHashKey);
            setCurrentPage(Math.ceil((hashkeys.indexOf(path2) + 1) / itemsPerPage));
            scroll(path2);
        }
    }, [filterUserList, path2, itemsPerPage])
    useEffect(() => {
        const path = history.location.pathname;
        const path3 = path.split("/")[3];
        if(path3 !== "Edit"){
            history.replace(path.split("/").slice(0, 3).join("/"));
        }else{
            history.replace(path.split("/").slice(0, 4).join("/"));
        }
    }, [])
    // useEffect(() => {
    //     if(path2 && path3 !== "Edit") history.replace(`/${path1}/${path2}`);
    // },[history, path1, path2, path3])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    {tabTitle}
                    <span data-toggle = "tooltip" title = {"Refreshed on " + updateDateTime} className = "btn btn-primary py-1 ml-4" onClick = {() => setUpdateDateTime(getTimeStamp())}>↻</span>
                </span>
                <span>
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                <WeekSelect
                    curWeekStart = {curWeekStart}
                    setWeekStart = {setWeekStart}
                    curWeekEnd = {curWeekEnd}
                    setWeekEnd = {setWeekEnd}
                    setCurrentPage = {setCurrentPage}
                    history = {history}
                    path1 = {path1}
                    beginWeek = "2022/8/11"
                />
                {curType === "Calibration Verification Form"?
                <>
                <span className = "pointer" onClick = {() => setShowStatusForm(true)}>
                    Status
                </span>
                {showStatusForm?
                <StatusForm
                    userList = {userList}
                    closeIt = {() => setShowStatusForm(false)}
                />
                :<></>}
                </>
                :<></>}
                {curType === "Weekly Maintenance Zerk Fittings"?
                <span className = "d-flex align-items-center">
                    <label className = "mb-0" htmlFor = "truckNumber">
                        Truck:
                    </label>
                    <select
                        id = "truckNumber"
                        className = "ml-2 form-control w-auto ml-2"
                        value = {curTruck}
                        onChange = {e => {
                        setTruck(e.currentTarget.value);
                        setCurrentPage(1);
                    }}>
                        <option value = {""}>All</option>
                        {userList.filter(form => form.formType === "Weekly Maintenance Zerk Fittings").map(form => JSON.parse(form.formContent || "{}")["Truck Number"]).filter(onlyUnique).map((opt, optIndex) => <option key = {optIndex} value = {opt}>{opt}</option>)}
                    </select>
                </span>
                :<></>}
                {curType === "Weekly Maintenance Zerk Fittings"?
                <span className = "d-flex align-items-center">
                    <label className = "mb-0" htmlFor = "truckNumber">
                        Date:
                    </label>
                    <select
                        id = "truckNumber"
                        className = "form-control w-auto ml-2"
                        value = {curDate}
                        onChange = {e => {
                        setDate(e.currentTarget.value);
                        setCurrentPage(1);
                    }}>
                        <option value = {""}>All</option>
                        {userList.filter(form => form.formType === "Weekly Maintenance Zerk Fittings").map(form => JSON.parse(form.formContent || "{}")["Date"]).filter(onlyUnique).map((opt, optIndex) => <option key = {optIndex} value = {opt}>{opt}</option>)}
                    </select>
                </span>
                :<></>}
                <span className = "d-flex align-items-center">
                    <label htmlFor = "type" className = "mb-0">Type:</label>
                    <select
                        id = "type"
                        className = "form-control w-auto ml-2"
                        value = {curType}
                        onChange = {e => {
                            const value = e.currentTarget.value;
                            setType(value);
                            if(value !== "Weekly Maintenance Zerk Fittings"){
                                setTruck("");
                                setDate("");
                            }
                            setCurrentPage(1);
                        }}
                    >
                        <option value = {""}>All</option>
                        {opts.map((opt, optIndex) => <option key = {optIndex} value = {opt}>{opt}</option>)}
                    </select>
                </span>
                <span className = "pointer" onClick = {() => setHistory(h => !h)}>
                    {isHistory?"Active":"History"}
                </span>
                <span className = "pointer rounded p-1" style = {{
                    backgroundColor: Object.entries(curFilter).find(([key, value]) => defaultFilter[key] !== value)?
                    "rgb(0,123,255)"
                    :""
                }} onClick = {() => {setShowFilterForm(true)}}>
                    Filter
                </span>
                {showFilter?
                <FilterForm
                    usersList = {usersList}
                    setCurrentPage = {setCurrentPage}
                    curFilter = {curFilter}
                    setFilter = {setFilter}
                    closeIt = {() => setShowFilterForm(false)}
                    defaultFilter = {defaultFilter}
                />:<></>}
                <Export
                    filterUserList = {filterUserList}
                />
                <span onClick = {() => {
                    history.push(`/${path1}/Add`);
                }}>
                    Add
                </span>
                {path2 === "Add"?
                <AddForm
                    setUserList = {setUserList}
                    keyword = "Add"
                    closeIt = {() => {
                        // if(adminLink){
                        //     history.push(`${adminLink}/${id}`);
                        // }else{
                            history.push(`/${path1}`);
                        // }
                    }}
                    sketches = {formSketches}
                    setSketches = {formSetSketches}
                    picData = {formPicData} 
                    setPicData = {formSetPicData}
                />:<></>}
            </div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !filterUserList.length?<div className = "cssLoading">Empty</div>:
                <div className = "table-responsive">
                    <table className = "table">
                        <thead className = "noTableTopBorder">
                            <tr>
                                <th></th>
                                {!isMobilePhone?<>
                                <th>Name</th>
                                <th>Department</th>
                                </>:<></>}
                                <th>Type</th>
                                {!isMobilePhone?<>
                                <th>Created On</th>
                                <th>Saved On</th>
                                <th>Submitted On</th>
                                <th>Approver</th>
                                <th>Completed On</th>
                                <th>Completed by</th>
                                </>:<></>}
                                <th>Status</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentUserList.sort((a, b) => objDescSort(a, b, "dateCreated")).map((form, key) => 
                            <Fragment key = {key}>
                            <tr id = {form.formHashKey}
                            style = {{
                                color:statusColorCode(form.status),
                                cursor:[
                                    ...usersList.filter(u => u.forms === "approver").map(u => u.email),
                                    form.approverEmail,
                                    form.submitterEmail,
                                    JSON.parse(form.formContent || "{}")["Tech"]
                                ].includes(user.email)?"pointer":""
                            }} onClick = {e => {
                                if(!e.target.id){
                                    if([
                                        ...usersList.filter(u => u.forms === "approver").map(u => u.email),
                                        form.approverEmail,
                                        form.submitterEmail,
                                        JSON.parse(form.formContent || "{}")["Tech"]
                                    ].includes(user.email) && path2 !== e.currentTarget.id){
                                        history.push(`/${path1}/${e.currentTarget.id}`);
                                        scroll(e.currentTarget.id);
                                    }else{
                                        history.push(`/${path1}`);
                                        scroll(null);
                                    }
                                }
                            }}>
                                <td className = {
                                    ![
                                        ...usersList.filter(u => u.forms === "approver").map(u => u.email),
                                        form.approverEmail,
                                        form.submitterEmail
                                    ].includes(user.email)?"":path2 === form.formHashKey?"showMinus":"showPlus"}></td>
                                {!isMobilePhone?<>
                                <td id = {form.submitterEmail}>
                                    <UserInfo 
                                        name = {form.submitter}
                                        email = {form.submitterEmail}
                                    />
                                </td>
                                <td>{form.department}</td>
                                </>:<></>}
                                <td>{form.formType}</td>
                                {!isMobilePhone?<>
                                <td>{form.dateCreated}</td>
                                <td>{!form.dateSaved?"":form.dateSaved}</td>
                                <td>{!form.dateSubmitted?"":form.dateSubmitted}</td>
                                <td>
                                    <UserInfo 
                                        name = {form.approver}
                                        email = {form.approverEmail}
                                    />
                                </td>
                                <td>{!form.dateCompleted?"":form.dateCompleted}</td>
                                <td>
                                    <UserInfo 
                                        name = {usersListMap?.[form.completerEmail]}
                                        email = {form.completerEmail}
                                    />
                                </td>
                                </>:<></>}
                                <td>{form.status}</td>
                                <td>
                                    {["Submitted", "Handled"].includes(form.status) && ([
                                        ...usersList.filter(u => u.forms === "approver").map(u => u.email),
                                        form.approverEmail,
                                        form.submitterEmail
                                    ].includes(user.email) || user.form === "all")?
                                    <span id = {form.id} className = "btn btn-success" onClick = {async() => {
                                        if(!form.id){
                                            window.alert("PDF Error.");
                                            return
                                        };
                                        const formData = new MyFormData();
                                        formData.append("fileId[]", form.id);
                                        //---------------------------------------------------------------
                                        setShowLoader(true);
                                        const res = await myAxios("common/getFile.php", formData, "blob");
                                        setShowLoader(false);
                                        if(!res) return;
                                        //---------------------------------------------------------------
                                        const file = new Blob([res.data], {type: mimeTypeMap.pdf});
                                        saveAs(file, `${form.formType} - ${form.dateCreated}.pdf`);
                                    }}>
                                        Form
                                    </span>
                                    :<></>}
                                </td>
                            </tr>
                            <tr>
                                <td className = "noborder" colSpan = {100}>
                                    <TransitionWidthHeight
                                        classNames = "cssTDTransition"
                                        In = {[
                                            form.submitterEmail, 
                                            form.approverEmail, 
                                            ...usersList.filter(u => u.forms === "approver").map(u => u.email),
                                            JSON.parse(form.formContent || "{}")["Tech"]
                                        ].includes(user.email) && path2 ===  form.formHashKey}
                                    >
                                        <Detail
                                            setUserList = {setUserList}
                                            usersListMap = {usersListMap}
                                            path1 = {path1}
                                            path2 = {path2}
                                            path3 = {path3}
                                            form = {form}
                                            forms = {filterUserList}
                                            history = {history}
                                            setHistory = {setHistory}
                                            usersList = {usersList}
                                            formSketches = {formSketches}
                                            formSetSketches = {formSetSketches}
                                            formPicData = {formPicData} 
                                            formSetPicData = {formSetPicData}
                                        />
                                    </TransitionWidthHeight>
                                </td>
                            </tr>
                            </Fragment>)}
                        </tbody>
                    </table>
                </div>}
                {!showLoading && filterUserList.length?
                <Footer
                    length = {filterUserList.length}
                    pageNumbers = {pageNumbers}

                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}
                />
                :null}
            </div>
        </div>
    )
}